import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { LoggerService } from '../shared/logger/logger.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * This service is used to check if user is allowed to navigate to certain route.
 */
@Injectable()
export class LoggedInGuard implements CanActivate {

  /**
   * Default constructor
   * @param {AuthService} auth
   * @param {LoggerService} logger
   */
  constructor(private auth: AuthService, private logger: LoggerService) {
  }

  /**
   * Checker function for valid access token and permissions.
   * @returns {Promise<boolean>|boolean} - authenticated true/false
   */
  canActivate(): Observable<boolean> {
    return this.auth.login$.pipe(take(1), map(() => true));
  }
}
